import * as _ from "lodash";
import * as React from "react";
import classNames from "classnames";

import { CHEVRON_DOWN, CHEVRON_RIGHT, WARNING } from "../../../Constants";
import { OutotecIcons } from "../../General/Icons/";
import { isBuildType } from "../../../Helpers/build";

interface NavigationTextAreaProps {
    itemClass: string;
    level: number;
    type: string;
    description: string;
    state: string;
    isOpen: boolean;
    hasChildren: boolean;
    isMetso: boolean;

    onToggleLevel: () => any;
}

const NavigationTextArea: React.FC<NavigationTextAreaProps> = (
    props: NavigationTextAreaProps
) => {
    const obsolete: boolean =
        isBuildType(props?.type) &&
        props.state &&
        props.state?.toLowerCase() === "obsolete";
    const inactive: boolean =
        props.type?.toLowerCase() === "site" &&
        props.state &&
        (props.state.toLowerCase() === "inactive" ||
            props.state.toLowerCase() === "closed");
    const iconClass: string = classNames({
        "Icon--obsolete": obsolete,
        "Icon--inactive": inactive,
        "Icon--metso": props.isMetso,
    });

    return (
        <div className={props.itemClass}>
            <span className="NavigationTree__item--initialMarginLeft" />
            {_.times(props.level, (i: number) => (
                <span
                    key={`${i}${props.level}${props.description}`}
                    className="NavigationTree__item--indent"
                />
            ))}

            <OutotecIcons classNames={iconClass} type={props.type} />

            <p className="NavigationTree__item--text">{props.description}</p>
            <span
                className="NavigationTree__levelToggle"
                onClick={(e) => {
                    e.stopPropagation();
                    props.onToggleLevel();
                }}
            >
                {props.isOpen && props.hasChildren && (
                    <OutotecIcons type={CHEVRON_DOWN} />
                )}
                {!props.isOpen && props.hasChildren && (
                    <OutotecIcons type={CHEVRON_RIGHT} />
                )}
            </span>
        </div>
    );
};

export default NavigationTextArea;
